import { createNamespacer, createReducer } from './../commons/js/utils/reducer';

const initialState = {
    filters: {
        ActiveOrPast: "active",
        selectedProject: { value: null, label: '' },
        selectedWelder: { value: null, label: '' },
        selectedLot: { value: null, label: '' },
        selectedExaminer: { value: null, label: '' },
        projectsList: [],
        weldersList: [],
        lotList: [],
        examinersList: [],
        loading: false,
        weldInspectionData: [],
        totalPages: 1,
        currentPage: 1,
    }
}

const weldInspection = createNamespacer("WELD_INSPECTION");

const weldInspectionFiltersReducer = createReducer(initialState.filters, {
    [weldInspection("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            loading: action.payload.value,
        }
    },
    [weldInspection("ACTIVE_OR_PAST")]: (state, action) => {
        return {
            ...state,
            ActiveOrPast: action.payload.value,
        }
    },
    [weldInspection("SET_SELECTED_PROJECT")]: (state, action) => {
        return {
            ...state,
            selectedProject: action.payload.value,
        }
    },
    [weldInspection("SET_SELECTED_WELDER")]: (state, action) => {
        return {
            ...state,
            selectedWelder: action.payload.value,
        }
    },
    [weldInspection("SET_SELECTED_LOT")]: (state, action) => {
        return {
            ...state,
            selectedLot: action.payload.value,
        }
    },
    [weldInspection("SET_SELECTED_EXAMINER")]: (state, action) => {
        return {
            ...state,
            selectedExaminer: action.payload.value,
        }
    },
    [weldInspection("SET_WELD_INSPECTION_DATA")]: (state, action) => {
        return {
            ...state,
            weldInspectionData: action.payload.value,
            totalPages: action.payload.totalPages,
            currentPage: action.payload.currentPage,
        }
    },
    [weldInspection("SET_DROPDOWN_LIST")]: (state, action) => {
        return {
            ...state,
            projectsList: action.payload.projectList,
            lotList: action.payload.lotList,
            weldersList: action.payload.weldersList,
            examinersList: action.payload.examinersList,
        }
    },
});

export default weldInspectionFiltersReducer;